import { render, staticRenderFns } from "./RiskAddressScrubbingFailedModal.vue?vue&type=template&id=6ddfc72b"
import script from "./RiskAddressScrubbingFailedModal.vue?vue&type=script&lang=ts"
export * from "./RiskAddressScrubbingFailedModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports